import { lazy, ReactNode, Suspense } from 'react'
import { LocationData } from 'types'
import LoaderCover from '../LoaderCover'

const GoogleMap = lazy(() => import('./GoogleMap'))

interface Props {
  data: LocationData[]
  markers?: ReactNode[]
  onMarkerClick?: (marker: LocationData) => void
}

export default function Map({ data, markers, onMarkerClick }: Props) {
  return (
    <Suspense fallback={<LoaderCover show />}>
      <GoogleMap locations={data} onMarkerClick={onMarkerClick} markers={markers} />
    </Suspense>
  )
}
